import { put } from "redux-saga/effects";

import { appInstance, davInstance } from "axios-config";
import * as actions from "./actions";

export function* fetchAppSettingsStart() {
  try {
    const response = yield appInstance.get("/settings/all");

    yield put(actions.fetchAppSettingsSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* fetchAllPlansStart() {
  try {
    const response = yield davInstance.get("/plan/getPlansWithDiscount");

    if (response.data.code === 200)
      yield put(actions.fetchAllPlansSuccess(response.data.message));
  } catch (error) {
    console.log(error);
  }
}
